[
  {
    "label": "Heti varastosta",
    "urlParam": "varastossa",
    "type": "toggle",
    "widget": "toggle",
    "attributePath": "stock.stockStatus",
    "attributeValue": "inStock"
  },
  {
    "label": "Alennuksessa",
    "urlParam": "alennuksessa",
    "type": "toggle",
    "widget": "toggle",
    "attributePath": "finalPrice.isOnSale",
    "attributeValue": "true"
  },
  {
    "label": "Hinta",
    "urlParam": "hinta",
    "type": "range",
    "widget": "range",
    "attributePath": "finalPrice.inclTax",
    "unit": "€"
  },
  {
    "label": "Väri",
    "urlParam": "vari",
    "type": "multiselect",
    "widget": "refinementList",
    "searchable": true,
    "searchPlaceholderText": "Etsi väriä",
    "attributePath": "technicalSpecifications.color.value"
  },
  {
    "label": "Koko",
    "urlParam": "koko",
    "type": "multiselect",
    "widget": "refinementList",
    "searchable": true,
    "searchPlaceholderText": "Etsi kokoa",
    "attributePath": "technicalSpecifications.size.value"
  },
  {
    "label": "Brändi",
    "urlParam": "brandi",
    "type": "multiselect",
    "widget": "refinementList",
    "searchable": true,
    "searchPlaceholderText": "Etsi brändiä",
    "attributePath": "marketing.productManufacturer.value"
  },
  {
    "label": "Kategoria",
    "urlParam": "kategoria",
    "type": "multiselect",
    "widget": "refinementList",
    "searchable": true,
    "searchPlaceholderText": "Etsi kategoriaa",
    "attributePath": "categories.value"
  },
  {
    "label": "Myymälän varastossa",
    "urlParam": "myymalasta",
    "type": "multiselect",
    "widget": "refinementList",
    "attributePath": "stock.availableInStores"
  },
  {
    "label": "Mönkijän tyyppi",
    "urlParam": "monkijan-tyyppi",
    "type": "multiselect",
    "widget": "refinementList",
    "attributePath": "techSpecs.techSpecProductAtvType.value",
    "includeInPaths": [
      "/category/ajoneuvot/monkijat"
    ]
  },
  {
    "label": "Moottoripyörän tyyppi",
    "urlParam": "moottoripyoran-tyyppi",
    "type": "multiselect",
    "widget": "refinementList",
    "attributePath": "techSpecs.techSpecProductMotorbikeType.value",
    "includeInPaths": [
      "/category/ajoneuvot/moottoripyorat"
    ]
  },
  {
    "label": "Vaihteisto",
    "urlParam": "vaihteisto",
    "type": "multiselect",
    "widget": "refinementList",
    "attributePath": "techSpecs.techSpecProductTransmission.value",
    "includeInPaths": [
      "/category/ajoneuvot/moottoripyorat"
    ]
  },
  {
    "label": "Kuutiotilavuus",
    "urlParam": "kuutiotilavuus",
    "type": "multiselect",
    "widget": "refinementList",
    "attributePath": "techSpecs.techSpecProductEngineDisplacement.value",
    "includeInPaths": [
      "/category/ajoneuvot/moottorikelkat",
      "/category/ajoneuvot/monkijat",
      "/category/ajoneuvot/moottoripyorat"
    ]
  },
    {
    "label": "Vuosimalli",
    "urlParam": "vuosimalli",
    "type": "multiselect",
    "widget": "refinementList",
    "attributePath": "techSpecs.techSpecProductYearModel.value",
    "includeInPaths": [
      "/category/ajoneuvot/moottorikelkat",
      "/category/ajoneuvot/monkijat",
      "/category/ajoneuvot/moottoripyorat"
    ]
  },
  {
    "label": "Moottorikelkan tyyppi",
    "urlParam": "moottorikelkan-tyyppi",
    "type": "multiselect",
    "widget": "refinementList",
    "attributePath": "techSpecs.techSpecProductSnowmobileType.value",
    "includeInPaths": [
      "/category/ajoneuvot/moottorikelkat"
    ]
  },
  {
    "label": "Moottorin tyyppi",
    "urlParam": "moottorin-tyyppi",
    "type": "multiselect",
    "widget": "refinementList",
    "attributePath": "techSpecs.techSpecProductEngineType.value",
    "includeInPaths": [
      "/category/ajoneuvot/moottorikelkat"
    ]
  },
  {
    "label": "Kypärän tyyppi",
    "urlParam": "kyparan-tyyppi",
    "type": "multiselect",
    "widget": "refinementList",
    "attributePath": "techSpecs.techSpecProductHelmetType.value",
    "includeInPaths": [
      "/category/ajovarusteet-ja-tyovaatteet/mp-ajovarusteet/mp-kyparat",
      "/category/ajovarusteet-ja-tyovaatteet/kelkkailuvarusteet/kyparat"
    ]
  },
  {
    "label": "Käyttäjä",
    "urlParam": "kayttaja",
    "type": "multiselect",
    "widget": "refinementList",
    "attributePath": "techSpecs.techSpecProductClothUser.value",
    "includeInPaths": [
      "/category/ajovarusteet-ja-tyovaatteet",
      "/category/vapaa-aika-ja-koti/vaatetus"
      
    ]
  },
  {
    "label": "Renkaan profiili",
    "urlParam": "renkaan-profiili",
    "type": "multiselect",
    "widget": "refinementList",
    "attributePath": "techSpecs.techSpecProductWheelProfile.value",
    "includeInPaths": [
      "/category/ajoneuvotarvikkeet-ja-lisavarusteet/renkaat",
      "/category/ajoneuvotarvikkeet-ja-lisavarusteet/moottoripyoran-tarvikkeet-ja-lisavarusteet/moottoripyoran-renkaat"
    ]
  },
  {
    "label": "Renkaan puoli",
    "urlParam": "renkaan-puoli",
    "type": "multiselect",
    "widget": "refinementList",
    "attributePath": "techSpecs.techSpecProductTiresFrontOrRear.value",
    "includeInPaths": [
      "/category/ajoneuvotarvikkeet-ja-lisavarusteet/renkaat",
      "/category/ajoneuvotarvikkeet-ja-lisavarusteet/moottoripyoran-tarvikkeet-ja-lisavarusteet/moottoripyoran-renkaat"
    ]
  },
  {
    "label": "Renkaan leveys",
    "urlParam": "renkaan-leveys",
    "type": "multiselect",
    "widget": "refinementList",
    "attributePath": "techSpecs.techSpecProductWheelWidth.value",
    "includeInPaths": [
      "/category/ajoneuvotarvikkeet-ja-lisavarusteet/renkaat",
      "/category/ajoneuvotarvikkeet-ja-lisavarusteet/moottoripyoran-tarvikkeet-ja-lisavarusteet/moottoripyoran-renkaat"
    ]
  },
  {
    "label": "Vanteen halkaisija",
    "urlParam": "vanteen-halkaisija",
    "type": "multiselect",
    "widget": "refinementList",
    "attributePath": "techSpecs.techSpecProductRimSize.value",
    "includeInPaths": [
      "/category/ajoneuvotarvikkeet-ja-lisavarusteet/renkaat",
      "/category/ajoneuvotarvikkeet-ja-lisavarusteet/moottoripyoran-tarvikkeet-ja-lisavarusteet/moottoripyoran-renkaat"
    ]
  }
]
